import axios from "axios";
import { BASE_URL } from "./Constant";

const HttpClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    // "Content-Type": "application/json",
    Accept: "application/json",
  },
});

HttpClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token") || "";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default HttpClient;
